import { Component, HostListener, Inject, NgZone, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { IconsComponent } from '@chant/icons';
import { SlideLeftToRightAnimation } from '@chant/utility';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, IconsComponent, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [SlideLeftToRightAnimation]
})
export class HeaderComponent implements OnInit {

  public showNavigation = false;
  public showNavToggleButton = false;
  public showServiceMenu = false;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngOnInit(): void {
    this.ngZone.run(() => {
      this.handleResizedEvents();
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
       this.handleResizedEvents();
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.handleResizedEvents();
  }

  handleResizedEvents(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth <= 1024) {
        this.showNavigation = false;
        this.showNavToggleButton = true;
        this.showServiceMenu = false;
        this.document.body.classList.remove('overflow-hidden');
      } else {
        this.showNavigation = true;
        this.showNavToggleButton = false;
        this.showServiceMenu = true;
      }
    }
  }

  navigationToggle(): void {
    this.showNavigation = !this.showNavigation;
    if (this.showNavigation) {
      this.document.body.classList.add('overflow-hidden');
    } else {
      this.document.body.classList.remove('overflow-hidden');
    }
  }

  closeAideNavigation(): void {
    if (isPlatformBrowser(this.platformId))
      if (window.innerWidth <= 1199) {
        this.showNavigation = false;
        this.showServiceMenu = false;
      }
  }

  toggleServiceMenu(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth <= 1024) {
        this.showServiceMenu = !this.showServiceMenu;
      }
    }
  }
}
